import { reportActionTypes } from '@/pages/report/Constants';
import { ReportAction, ReportState } from '@/pages/report/types';

const initialState: ReportState = {
	loading: false,
	playListSection: null,
	playListSections: {},
};

export default function reportReducer(
	state: ReportState = initialState,
	action: ReportAction,
): ReportState {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case reportActionTypes.GET_PLAYLIST_SECTION_REPORT_REQUEST:
			return {
				...state,
				loading: true,
			};

		case reportActionTypes.GET_PLAYLIST_SECTION_REPORT_SUCCESS:
			return {
				...state,
				playListSection: data || null,
				playListSections: data
					? { ...state.playListSections, [data.id]: data }
					: state.playListSections,
				loading: false,
			};

		case reportActionTypes.GET_PLAYLIST_SECTION_REPORT_ERROR:
			return {
				...state,
				loading: false,
			};

		case reportActionTypes.CLEAR_STATE:
			return {
				...state,
				playListSection: {},
			};

		default:
			return state;
	}
}
